/**
 * @generated SignedSource<<f3d65e10e44e69b72540b21e3255666b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DisplayPromoCode_user$data = {
  readonly preferences: {
    readonly currency: Currency | null;
  } | null;
  readonly " $fragmentType": "DisplayPromoCode_user";
};
export type DisplayPromoCode_user$key = {
  readonly " $data"?: DisplayPromoCode_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"DisplayPromoCode_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DisplayPromoCode_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserPreferences",
      "kind": "LinkedField",
      "name": "preferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "1a23a8486f1dac1392cc3443a6f2e0e4";

export default node;
